import config from 'src/config';
import logoMiniUrl from 'assets/images/logo-mini.png';
import defaultProfilePicUrl from 'assets/images/default_profile_pic.jpg';

function SidebarCtrl($scope, $state, $timeout, $rootScope, authService, managementUserService, $sce, organizationService, $stateParams, userPreferencesService, imgixService, SIDEBAR_LINKS, venueService) { //eslint-disable-line
  _initScope();

  function _initScope() {
    $scope.user = managementUserService.getCurrentUser();
    $scope.isPromoter = organizationService.isCurrentOrganizationAPromoter();

    $scope.SIDEBAR_LINKS = SIDEBAR_LINKS;
    $scope.activeSidebarLink = $state.current.data.SIDEBAR_LINK;
    $scope.currentAppVersion = config.VERSION;

    $scope.goToManage = function ($event) {
      $event.preventDefault();

      const managePage = userPreferencesService.getManagePage();

      if (managePage === 'DASHBOARD') {
        $state.go('app.organization.manage.dashboard', {
          venueId: $scope.getCurrentVenueId()
        });
      } else if (managePage === 'RESERVATIONS') {
        $state.go('app.organization.manage.reservations', {
          venueId: $scope.getCurrentVenueId()
        });
      } else if (managePage === 'ADMISSIONS') {
        $state.go('app.organization.manage.guestlists', {
          venueId: $scope.getCurrentVenueId()
        });
      } else if (managePage === 'INVENTORY') {
        $state.go('app.organization.manage.inventory', {
          venueId: $scope.getCurrentVenueId()
        });
      } else {
        $state.go('app.organization.manage.reservations', {
          venueId: $scope.getCurrentVenueId()
        });
      }
    };
    //
    $scope.logoMiniUrl = logoMiniUrl;

    $rootScope.$on('$stateChangeSuccess', (event, toState) => {
      if (toState && toState.data) {
        $scope.activeSidebarLink = toState.data.SIDEBAR_LINK;
      }
    });

    $scope.getCurrentVenueId = function () {
      const currentVenue = venueService.getCurrentVenue();
      return currentVenue ? currentVenue.id : null;
    };

    managementUserService.on(managementUserService.EVENTS.USER_UPDATED, function () {
      $scope.user = managementUserService.getCurrentUser();
    });

    $scope.helpCenterUrl = $sce.trustAsResourceUrl(config.HELP_CENTER_URL);

    $scope.userProfilePicture = function () {
      try {
        return imgixService.url($scope.user.profileImage, {
          width: 60,
          height: 60
        });
      } catch (err) {
        return defaultProfilePicUrl;
      }
    };
  }
}

SidebarCtrl.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$rootScope',
  'authService',
  'jsSdk.managementUser',
  '$sce',
  'organizationService',
  '$stateParams',
  'userPreferencesService',
  'jsSdk.imgix',
  'SIDEBAR_LINKS',
  'venueService'
];

export default SidebarCtrl;



// WEBPACK FOOTER //
// ./src/directives/sidebar/controller.js